import * as z from 'zod/v4';

import { drawNumberSchema } from '../draw/entry.js';
import { dateTimeSchema } from '../frameworks/entry.js';
import { currencySchema, customerIdSchema, winDivisionSchema } from '../lib/entry.js';
import { productSchema } from '../product/entry.js';

// Add 1 to win division to align with forecast
const wagerWinDivisionSchema = z
  .number()
  .transform((val) => val + 1)
  .pipe(winDivisionSchema);

const winType = {
  WIN: 1,
  REFUND: 2,
};
const winTypeSchema = z
  .union([z.literal(1), z.literal(2)])
  .transform((val) => {
    switch (val) {
      case winType.WIN:
        return 'WIN';
      case winType.REFUND:
        return 'REFUND';
      default:
        return 'UNKNOWN';
    }
  })
  .catch('UNKNOWN');
export type WinType = z.infer<typeof winTypeSchema>;

const payoutTargetSchema = z
  .enum(['Bank', 'Ombudsterminal', 'Intern validering', 'Spelkontot'])
  .transform((payoutTargetString) => {
    switch (payoutTargetString) {
      case 'Bank':
        return 'BANK';
      case 'Ombudsterminal':
        return 'RETAILER_TERMINAL';
      case 'Intern validering':
        return 'INTERNAL_VALIDATION';
      case 'Spelkontot':
        return 'GAME_ACCOUNT';
      default:
        return 'UNKNOWN';
    }
  })
  .catch('UNKNOWN');
export type PayoutTarget = z.infer<typeof payoutTargetSchema>;

export const windDivisionSchema = z
  .object({
    customerId: customerIdSchema,
    time: dateTimeSchema,
    amount: currencySchema,
    drawNumber: drawNumberSchema,
    /* Number of wins, this is same as count prop that is not parsed */
    numWins: z.number(),
    productId: productSchema,
    winDiv: wagerWinDivisionSchema,
    winType: winTypeSchema,
    payoutDone: z.boolean(),
    payoutTime: dateTimeSchema,
    payoutTarget: payoutTargetSchema,
    fractionCount: z.number(),
    /* Customer needs to contact customer services, too high win */
    isOnHold: z.unknown(),
  })
  .transform(({ winDiv: winDivision, numWins: numberOfWins, fractionCount: totalFractionCount, ...windDivision }) => {
    return {
      ...windDivision,
      numberOfWins,
      winDivision,
      totalFractionCount,
    };
  });
